<template>
  <v-container container--fluid fill-height class="pa-0">
    <!-- <v-row class="fill-height" no-gutters justify="center">
      <v-col lg="3" md="4" cols="10" :class="{ white: $vuetify.breakpoint.mdAndUp }">
        <v-row :align="$vuetify.breakpoint.mdAndUp ? 'start' : 'center'" class="fill-height">
          <v-col>
            <v-card flat class="px-8 mt-8" color="white">
              <div class="text-center">
                <img
                  height="200"
                  src="https://cdn.siap.id/s3/siap_belajar/sim/logo-siap-belajar.png"
                />
              </div>
              <v-card-text>
                <v-form autocomplete="on" @submit.prevent data-vv-scope="form" lazy-validation>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        outlined
                        dense
                        placeholder="Alamat Surel"
                        append-icon="mdi-gmail"
                        name="email"
                        type="text"
                        autofocus
                        color="primary"
                        background-color="white"
                        v-model.trim="model.email"
                        data-vv-name="email"
                        data-vv-as="Surel"
                        v-validate="'required|email'"
                        @keyup.enter="login"
                        :error-messages="errors.collect('form.email')"
                      ></v-text-field>
                      <v-text-field
                        outlined
                        dense
                        placeholder="Kata Sandi"
                        :append-icon="appendIcon"
                        @click:append="switchVisibility"
                        name="password"
                        id="password"
                        :type="passwordFieldType"
                        color="primary"
                        background-color="white"
                        v-model="model.password"
                        data-vv-name="password"
                        data-vv-as="Kata Sandi"
                        v-validate="'required'"
                        @keyup.enter="login"
                        :error-messages="errors.collect('form.password')"
                      ></v-text-field>
                      <v-alert
                        v-if="errorMessage"
                        class="caption mt-2 mr-5"
                        text
                        prominent
                        type="error"
                        icon="mdi-cloud-alert"
                      >Informasi email/username atau kata sandi tidak benar</v-alert>
                      <div>
                        <v-btn
                          block
                          depressed
                          color="primary font-weight-bold white--text"
                          @click="login"
                        >Masuk</v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col lg="9" md="8" sm="6" class="bg d-none d-md-flex"></v-col>
    </v-row>-->
  </v-container>
</template>

<script>
import ChangeDlg from "../components/Register.vue";
import { SITE_KEY, BASE_API, CLIENT_ID, CLIENT_SECRET } from "@/const";
import ForgotPassword from "../components/ForgotPassword.vue";
const lc = window.localStorage;
const TOKEN = "token";
export default {
  components: {
    ChangeDlg,
    ForgotPassword,
  },
  $_veeValidate: {
    validator: "new",
  },
  data: () => ({
    drawer: true,
    loading: false,
    appendIcon: "mdi-eye-off",
    passwordFieldType: "password",
    ForgotPassword: false,
    errorMessage: false,
    registerForm: {
      recaptchaVerified: false,
      pleaseTickRecaptchaMessage: "",
    },
    model: {
      email: null,
      password: null,
      grant_type: null,
    },
  }),
  mounted() {
    lc.removeItem(TOKEN);
    this.$validator.reset();
    this.checkQuery();
  },
  computed: {
    sitekey() {
      return SITE_KEY;
    },
  },
  methods: {
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
      this.passwordFieldType === "password"
        ? (this.appendIcon = "mdi-eye-off")
        : (this.appendIcon = "mdi-eye");
    },
    login() {
      // this.checkIfRecaptchaVerified();
      this.loading = true;
      this.$validator
        .validateAll("form")
        .then((res) => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          // if (this.registerForm.recaptchaVerified) {
          if (!this.CONFIG.INSTANSI_ID) {
            return this.$store.dispatch("user/login", {
              grant_type: "password",
              client_id: CLIENT_ID,
              client_secret: CLIENT_SECRET,
              username: this.model.email,
              password: this.model.password,
            });
          } else {
            return this.$store.dispatch("user/login", {
              grant_type: "password",
              client_id: CLIENT_ID,
              client_secret: CLIENT_SECRET,
              username: this.model.email,
              password: this.model.password,
              instansi_id: this.CONFIG.INSTANSI_ID
                ? this.CONFIG.INSTANSI_ID
                : this.model.instansi_id,
            });
          }
          // }
        })
        .then((res) => {
          if (res && res.error == "invalid_credentials") {
            this.errorMessage = true;
          } else {
            this.$router.push({ name: "beranda" });
          }

          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    checkQuery() {
      if (this.$route.query.token) {
        this.token = this.$route.query.token;
        // clean query
        window.history.replaceState({}, document.title, "/login");
        // langsung lakukan verifikasi
        this.$nextTick(() => {
          this.verify();
        });
      } else {
        if (lc.getItem(TOKEN)) {
          this.$router.push({ name: "instansi.pilih" });
        } else {
          window.location.href = BASE_API;
        }
      }
    },
    verify() {
      this.$validator
        .validateAll("form")
        .then((res) => {
          if (!res) return Promise.reject();
        })
        .then(() => {
          this.loading = true;
          this.$store
            .dispatch("user/login", { token: this.token })
            .then((res) => {
              this.loading = false;
              res.id ? this.st++ : Promise.reject;
            })
            .catch(() => {
              this.loading = false;
            });
        })
        .catch((e) => e);
    },
  },
};
</script>
<style scoped lang="css">
.bg {
  /* The image used */
  background-image: url("https://cdn.siap.id/s3/siap_belajar/sim/bg-login-siap-belajar.png");

  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>